import {gql} from 'apollo-angular';

export const joinRoomMutation = gql`
  mutation joinRoom($accessCode: String, $lang: String, $gameId: Int!) {
    room:joinRoom (
      accessCode: $accessCode,
      lang: $lang,
      gameId: $gameId,
    ) {
      
      entity {
        userId
        avatar
        connected
        deviceDetected
        deviceIdentifier
        host
        jokerFiftyFifty
        jokerSkip
        language
        location
        name
        score
        playInactivityCounter
        playingTime
      }
    }
}`;